import { fetchMessages } from '@/api/translations'
import locator from '@/service-locator'
const RIGHT_TO_LEFT_LANGS = ['ar']

const state = {
  locale: '',
  messages: {},
  direction: 'ltr',
  fetchingMessage: false,
}

const getters = {
  isFetchingMessage: (state) => state.fetchingMessage,
  messages: (state) => {
    return state.messages || {}
  },
  currentLocale: (state) => {
    return state.locale
  },
  currentLang: (state) => {
    const locale = state.locale.replace('-', '_')
    const [lang] = locale.split('_')

    return lang || 'en'
  },
  hasLocale: (state) => {
    return !!state.locale
  },
  currentDirection: (state) => {
    return state.direction
  },
  isRightToLeftDirection: () => {
    return state.direction === 'rtl'
  },
  isArabic: (_, getters) => {
    return getters.currentLang === 'ar'
  },
}

const mutations = {
  UPDATED_FETCHING_MESSAGES: (state, fetching) => {
    state.fetchingMessage = fetching
  },
  UPDATE_LOCALE: (state, locale) => {
    state.locale = locale
  },
  UPDATE_MESSAGES: (state, { messages, locale }) => {
    state.messages = { ...state.messages, [locale]: messages }
  },
  SET_DIRECTION: (state, direction) => {
    state.direction = direction
  },
}

const actions = {
  fetchMessages({ commit, dispatch, state, getters, rootGetters }, locale) {
    commit('UPDATE_LOCALE', locale)

    if (state.messages[locale]) {
      // Trigger change direction
      dispatch('setDirectionByLocale', locale)

      return state.messages[locale]
    }
    commit('UPDATED_FETCHING_MESSAGES', true)

    const messages = fetchMessages(locale)

    commit('UPDATE_MESSAGES', { messages, locale })
    commit('UPDATED_FETCHING_MESSAGES', false)

    // Trigger change direction
    dispatch('setDirectionByLocale', locale)

    const selectedMerchant = rootGetters['userProfile/selectedMerchant']
    if (selectedMerchant) {
      locator.tracking.identify(selectedMerchant, {
        language: getters.currentLang,
      })
    }

    return messages
  },

  setDirectionByLocale({ commit }, locale) {
    const [lang] = locale.replace('-', '_').split('_')

    if (RIGHT_TO_LEFT_LANGS.includes(lang)) {
      return commit('SET_DIRECTION', 'rtl')
    }

    commit('SET_DIRECTION', 'ltr')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
